import React, { useState, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import RecipientForm from './recipientForm'
import { Recipient } from '../../../models/Recipient'
import Layout from '../../common/layout/layout'
import { useParams, useHistory } from 'react-router-dom'
import { getRecipient, updateRecipient } from '../../../services/migrantService'
import { toast } from 'react-toastify'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import constants from '../../../config/constants'

const EditRecipient: React.FC = () => {
  let { recipientId } = useParams()
  const history = useHistory()
  const [isProcessing, setIsProcessing] = useState(false)
  const [recipient, setRecipient] = useState<Recipient | undefined>(undefined)

  useEffect(() => {
    if (recipientId) {
      try {
        getRecipient(recipientId).then(recipientDetail => {
          if (recipientDetail) {
            setRecipient(recipientDetail)
          }
        })
      } catch (err) {
        console.error('getRecipient error:', err)
        toast.error(friendlyMessageFor(err), { autoClose: false })
      }
    }
  }, [recipientId])

  const processRecipient = async (recipientDetail: Recipient) => {
    try {
      setIsProcessing(true)
      await updateRecipient(recipientDetail)
      toast.success(
        constants.alertMessage.docUpdated.replace('%s', 'Recipient')
      )
      setIsProcessing(false)
      history.goBack()
    } catch (err) {
      console.error('updateRecipient error:', err)
      toast.error(friendlyMessageFor(err), { autoClose: false })
      setIsProcessing(false)
    }
  }

  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto" data-testid="editRecipientFC">
          <Row>
            <Col>
              <h1 className="pageTitle" data-testid="pageTitle">
                Edit Recipient
              </h1>
            </Col>
          </Row>
          <hr />
          <RecipientForm
            recipient={recipient}
            isSelf={false}
            submitButtonText="Save changes"
            onSubmit={processRecipient}
            isProcessing={isProcessing}
          />
        </Col>
      </Row>
    </Layout>
  )
}

export default EditRecipient
